import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { ROUTES } from "../../sidebar/sidebar.component";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { Location } from "@angular/common";
import { AuthService } from "../../../generics/services/auth.service";
import { FirebaseMessagingService } from "src/app/generics/services/firebase-messaging.service";
import { User } from "src/app/user-management/models/user.model";
import * as moment from "moment";
import { UserPreferencesService } from "src/app/generics/services/user-preferences.service";
import { MatDialog } from "@angular/material/dialog";
import { ModalPasswordComponent } from "./modal-password/modal-password.component";
import { AppService } from "src/app/global/services/app.service";
import { NotificationHistoryService } from "src/app/generics/services/notification-history.service";
import { ReportsService } from "src/app/reports-management/services/reports.service";
import { SweetAlert2Service } from "src/app/generics/services/sweet-alert2.service";
import { TranslateService } from "@ngx-translate/core";

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
};

declare var $: any;
@Component({
  selector: "app-navbar-cmp",
  templateUrl: "navbar.component.html",
})
export class NavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  notifications: any[] = [];
  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private nativeElement: Node;
  private toggleButton: any;
  private sidebarVisible: boolean;
  private _router: Subscription;
  userAvatarUrl: string = undefined;
  userName: string = undefined;
  user: User;
  isAdmin: boolean = false;
  totalNotifications: number = 0;
  userSubs: Subscription;
  userThemeSubs: Subscription;
  darkModeSubs: Subscription;
  selectionColorSubs: Subscription;
  surfaceToneSubs: Subscription;
  // totalNotificationsSubs: Subscription;
  // notificationSubs: Subscription;
  AppService: AppService;

  isDarkMode: boolean = false;
  selectedAccentColor: string = "purple";
  get paletteColors() {
    return this.preferencesService.accentColors;
  }

  selectedSurfaceTone: string = "slate";
  surfaceTones = [
    { key: "slate", hex: "#64748b" },
    { key: "gray", hex: "#6b7280" },
    { key: "zinc", hex: "#71717a" },
    { key: "neutral", hex: "#737373" },
    { key: "stone", hex: "#78716c" },
  ];

  @ViewChild("app-navbar-cmp", { static: false }) button: any;

  constructor(
    private notificationHistory: NotificationHistoryService,
    private _appService: AppService,
    location: Location,
    private renderer: Renderer2,
    private element: ElementRef,
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private fcmService: FirebaseMessagingService,
    private preferencesService: UserPreferencesService,
    private reportsService: ReportsService,
    private sweetAlert: SweetAlert2Service,
    private translateService: TranslateService
  ) {
    this.AppService = _appService;
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;

    this.userSubs = this.authService.currentUserSubs.subscribe((user) => {
      this.isAdmin = Number(
        (user as any)?.roleId ?? (user as any)?.roleID ?? 0
      ) === 1;
      if (user != null) {
        this.user = user;
        this.userAvatarUrl = user.avatarUrl;
        this.userName = user["userName"];
      }
    });

    // this.totalNotificationsSubs = this.fcmService.totalNotifications.subscribe(total => this.totalNotifications = total);
    // this.notificationSubs = this.fcmService.notifications.subscribe(n => {
    //   if (n != null) {
    //     this.notifications = n;
    //   }
    // });

    // Visibility API
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
      } else {
        if (!this.user) return;
        this.fcmService.updateNotifications(this.user?.id);
      }
    });
  }
  ngAfterViewInit(): void {
    this.userThemeSubs = this.authService.currentUserSubs.subscribe((user) => {
      this.preferencesService.reloadUserPreferences();
    });
    this.darkModeSubs = this.preferencesService.darkModeEnabledBehavior.subscribe((enabled) => {
      this.isDarkMode = enabled;
    });
    this.selectionColorSubs = this.preferencesService.selectionColorBehavior.subscribe((color) => {
      if (color) {
        this.selectedAccentColor = color;
      }
    });
    this.surfaceToneSubs = this.preferencesService.surfaceToneBehavior.subscribe((tone) => {
      if (tone) {
        this.selectedSurfaceTone = tone;
      }
    });
    this.updateNotification();
  }

  ngOnDestroy(): void {
    this.userSubs?.unsubscribe();
    this.userThemeSubs?.unsubscribe();
    this.darkModeSubs?.unsubscribe();
    this.selectionColorSubs?.unsubscribe();
    this.surfaceToneSubs?.unsubscribe();
    // this.totalNotificationsSubs?.unsubscribe();
    // this.notificationSubs?.unsubscribe();
  }

  toggleDarkMode() {
    this.preferencesService.darkModeEnabled = !this.preferencesService.darkModeEnabled;
  }

  selectAccentColor(colorKey: string) {
    this.preferencesService.selectionColor = colorKey;
  }

  selectSurfaceTone(toneKey: string) {
    this.preferencesService.surfaceTone = toneKey;
  }

  // markNotificationsAsRead() {
  //   this.fcmService.markNotificationsAsRead();
  //   this.updateNotification();
  // }

  // markSingleNotificationsAsRead(id: number, notification: NotificationHistory) {
  //   if (!id) return;
  //   console.log(id);
  //   console.log(notification);

  //   this.fcmService.markSingleNotificationsAsRead(id);

  //   if (notification.data) {
  //     let data: NotificationData = JSON.parse(notification.data);
  //     if (data.CallbackUri) {
  //       let url = new URL(data.CallbackUri);
  //       if (url.origin !=  window.location.origin) {
  //         data.CallbackUri = data.CallbackUri.replace(url.origin, window.location.origin);
  //       }
  //       // Default url
  //       // window.location.href = data.CallbackUri;
  //       this.router.navigateByUrl(data.CallbackUri.replace(window.location.origin, ''));
  //     }
  //   }
  // }

  getTimeAgoDate(dateTime: Date) {
    return moment(dateTime).fromNow();
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName("body")[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove("sidebar-mini");
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add("sidebar-mini");

        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  hideSidebar() {
    const body = document.getElementsByTagName("body")[0];
    const sidebar = document.getElementsByClassName("sidebar")[0];

    if (misc.hide_sidebar_active === true) {
      setTimeout(function () {
        body.classList.remove("hide-sidebar");
        misc.hide_sidebar_active = false;
      }, 300);
      setTimeout(function () {
        sidebar.classList.remove("animation");
      }, 600);
      sidebar.classList.add("animation");
    } else {
      setTimeout(function () {
        body.classList.add("hide-sidebar");
        // $('.sidebar').addClass('animation');
        misc.hide_sidebar_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event("resize"));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  ngOnInit() {
    this.listTitles = ROUTES.filter((listTitle) => listTitle);

    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton = navbar.getElementsByClassName("navbar-toggler")[0];
    if (body.classList.contains("sidebar-mini")) {
      misc.sidebar_mini_active = true;
    }
    if (body.classList.contains("hide-sidebar")) {
      misc.hide_sidebar_active = true;
    }
    this._router = this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this.sidebarClose();

        const $layer = document.getElementsByClassName("close-layer")[0];
        if ($layer) {
          $layer.remove();
        }
      });
  }
  onResize(event) {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
  sidebarOpen() {
    var $toggle = document.getElementsByClassName("navbar-toggler")[0];
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName("body")[0];
    setTimeout(function () {
      toggleButton.classList.add("toggled");
    }, 500);
    body.classList.add("nav-open");
    setTimeout(function () {
      $toggle.classList.add("toggled");
    }, 430);

    var $layer = document.createElement("div");
    $layer.setAttribute("class", "close-layer");

    if (body.querySelectorAll(".main-panel")) {
      document.getElementsByClassName("main-panel")[0].appendChild($layer);
    } else if (body.classList.contains("off-canvas-sidebar")) {
      document
        .getElementsByClassName("wrapper-full-page")[0]
        .appendChild($layer);
    }

    setTimeout(function () {
      $layer.classList.add("visible");
    }, 100);

    $layer.onclick = function () {
      //asign a function
      body.classList.remove("nav-open");
      this.mobile_menu_visible = 0;
      this.sidebarVisible = false;

      $layer.classList.remove("visible");
      setTimeout(function () {
        $layer.remove();
        $toggle.classList.remove("toggled");
      }, 400);
    }.bind(this);

    body.classList.add("nav-open");
    this.mobile_menu_visible = 1;
    this.sidebarVisible = true;
  }
  sidebarClose() {
    var $toggle = document.getElementsByClassName("navbar-toggler")[0];
    const body = document.getElementsByTagName("body")[0];
    this.toggleButton.classList.remove("toggled");
    var $layer = document.createElement("div");
    $layer.setAttribute("class", "close-layer");

    this.sidebarVisible = false;
    body.classList.remove("nav-open");
    // $('html').removeClass('nav-open');
    body.classList.remove("nav-open");
    if ($layer) {
      $layer.remove();
    }

    setTimeout(function () {
      $toggle.classList.remove("toggled");
    }, 400);

    this.mobile_menu_visible = 0;
  }
  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getPath() {
    return this.location.prepareExternalUrl(this.location.path());
  }

  goToSettings() {
    this.router.navigate(["/user/settings"]);
  }

  goToNotifications() {
    this.router.navigate(["/user/notifications"]);
  }

  logout() {
    this.authService.logout();
  }

  changePassword() {
    this.dialog.open(ModalPasswordComponent, {
      width: '450px',
      maxWidth: '90vw',
      disableClose: false,
      autoFocus: true
    });
  }

  async changeTressPassword() {
    const confirmed = await this._appService.showSweetAlertConfirm(
      this.translateService.instant('Change-Password.TressTitle'),
      this.translateService.instant('Change-Password.TressConfirmMessage'),
      'warning'
    );
    if (!confirmed) return;

    try {
      const response: any = await this.reportsService.resetTressPassword().toPromise();
      const html = `<div class="mt-2 mb-2">${this.translateService.instant('Change-Password.TressResultMessage')}</div><div class="tress-temp-password-box"><code>${response?.temporaryPassword}</code></div>`;
      await this.sweetAlert.showConfirm(
        this.translateService.instant('Change-Password.TressTitle'),
        html,
        'success',
        false
      );
    } catch (error: any) {
      const message = error?.error?.message || this.translateService.instant('Change-Password.TressError');
      this._appService.showNotification('danger', message);
    }
  }

  backClicked() {
    this.location.back();
  }

  async updateNotification() {
    let response: any[] = await this.notificationHistory
      .GetNotificationByUser(this._appService.UserLogin.id)
      .toPromise();
    this.totalNotifications = response.filter(
      (element) => element.state === false
    ).length;
    this.notifications = response;
  }
 
  getNotificationUrl(notificationTypeID: number): string {
    switch (notificationTypeID) {
      case 1:
        return "/purchasing/requisition";
      case 2:
        return "/purchasing/payment-request";
      case 3:
        return "/purchasing/against-receipt";
      default:
        return "/home";
    }
  }

  async markSingleNotificationsAsRead(item, openLink: boolean) {
    // Mark notification as read
    if (item.id) {
      this.notificationHistory.markSingleNotificationAsRead(item.id).toPromise().then(
        (res) => this.updateNotification()
      ).catch((error) => console.error("Error marking notification as read:", error));
    }

    // Navigate if openLink is true
    if (openLink && item.data) {
      const url = this.getNotificationUrl(item.notificationTypeID);
      this.router.navigate([url], {
        queryParams: { id: item.data },
      });
    }
  }

  async markNotificationsAsRead() {
    this.notificationHistory
      .markNotificationsAsRead(this._appService.UserLogin.id)
      .toPromise()
      .then((res) => this.updateNotification());
  }
}
